var _a;
import { IdLogging } from "./IdLogging";
export var LoggingConfigDefault = (_a = {},
    _a[IdLogging.Default] = true,
    _a[IdLogging.NetworkIn] = true,
    _a[IdLogging.NetworkOut] = true,
    _a[IdLogging.Graphics] = true,
    _a[IdLogging.Animation] = true,
    _a[IdLogging.LandingPages] = true,
    _a[IdLogging.Shop] = true,
    _a[IdLogging.Sound] = true,
    _a[IdLogging.Store] = true,
    _a[IdLogging.Tracking] = true,
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/utils/logging/LoggingConfigDefault.ts
// module id = 1129
// module chunks = 3